export default "/logo-university-washington.png";